import { wrapRequest } from "./nav";
const vueAppNeonApiUrl = import.meta.env.VITE_DESIGNER_APP_URL;
export const doFetchTemplateList = wrapRequest((sku) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return fetch(
    `${vueAppNeonApiUrl}/api/configuration_template/sku/${sku}?template_type=default,page_variant`,
    requestOptions
  );
});
